import React, { memo, useCallback, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { MessageOutlined as MessageOutlineIcon } from '@ant-design/icons';
import { Badge, Spin } from 'antd';

import chatService from 'v2/services/chat';

import Topbar from '@eduzz/ui-layout/Topbar';

import MessagesList from './MessagesList';

const ChatMessages = memo(() => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFirstOpen, setIsFirstOpen] = useState(true);

  const [unreadMessagesCount, unreadMessagesCountError] = useObservable(() => chatService.getChatUnreadCount(), []);

  const isLoadingCount = unreadMessagesCount === null && unreadMessagesCountError === undefined;

  const handleOpenChange = useCallback((open: boolean) => {
    setIsOpen(open);

    if (!open) {
      setIsFirstOpen(false);
    }
  }, []);

  if (isLoadingCount) {
    return <Spin size='small' />;
  }

  return (
    <MessagesList
      isFirstOpen={isFirstOpen}
      unreadMessagesCount={unreadMessagesCount}
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
    >
      <span>
        <Topbar.Action
          id='topbar-action-chat-messages'
          aria-label='mostrar mensagens'
          icon={
            <Badge count={unreadMessagesCount > 99 ? '99+' : unreadMessagesCount} size='small' offset={[4, -2]}>
              <MessageOutlineIcon style={{ fontSize: 24, color: 'currentColor' }} />
            </Badge>
          }
        />
      </span>
    </MessagesList>
  );
});

export default ChatMessages;
